// ==========================================================================
// Base
// ==========================================================================

/* global $ */

"use strict";


//Prevent # anchors jumping page to top
$('a[href="#"]').click(function (e) {
    e.preventDefault();
});


 var $profilegrid = $('.grid');
  $profilegrid.imagesLoaded( function() {

    $profilegrid.masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });
  });

  $(document).ready(function(){

    $('.owl-carousel').owlCarousel({
        margin:10,
        autoWidth:true,
        items:4
    })

      $('.owl-carousel-related').owlCarousel({

        items:4
    })
  });


  $(document).ready(function(){

    $(".filter-button").click(function(){
        var value = $(this).attr('data-filter');
        $('.btn-filter').removeClass('btn-primary');
        $('.btn-filter').addClass('btn-info');
        $(this).removeClass('btn-info');
        $(this).addClass('btn-primary');

        if(value == "all")
        {
            $('.filter').show('1000');
            $('.btn-filter').removeClass('btn-primary');
            $('.btn-filter').addClass('btn-info');
        }
        else
        {
            $('.btn-all').removeClass('btn-primary');
            $('.btn-all').addClass('btn-info');
            $(".filter").not('.'+value).hide('1000');
            $('.filter').filter('.'+value).show('1000');

        }
    });

});

function removeCurrentLogo()
{
   $('#currentLogo').hide();
   $('#newLogo').show();
}


